import Web3 from 'web3';

let web3Instance;

export const getWeb3 = () => {
  if (!web3Instance) {
    if (window.ethereum) {
      web3Instance = new Web3(window.ethereum);
    } else if (window.web3) {
      web3Instance = new Web3(window.web3.currentProvider);
    } else {
      console.error('No Ethereum browser extension detected.');
      return null;
    }
  }
  return web3Instance;
};